import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import LoginMenu from './LoginMenu';
import './NavMenu.css';
import Services from "../services/services";

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            isTestVersion: null
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    componentDidMount() {
        Services.getAppInfo((response) => {
            if (response?.status === 200) {
                this.setState({
                    isTestVersion: response.data.isTestVersion
                });
            } else {
            }
        });
    }

    render() {
        return (
            <header>
                <Navbar className="navbar-expand-lg navbar-toggleable-lg ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/">Hunt{this.state.isTestVersion ? " Test" : ""}</NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-lg-inline-flex flex-lg-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/elift">E-Lift</NavLink>
                                </NavItem>
                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret className="text-dark">PTI</DropdownToggle>
                                    <DropdownMenu right>
                                        <DropdownItem tag={Link} className="text-dark" to="/pti/dashboard">Dashboard</DropdownItem>
                                        <DropdownItem divider />
                                        <DropdownItem tag={Link} className="text-dark" to="/pti/fuel">Fuel</DropdownItem>
                                        <DropdownItem tag={Link} className="text-dark" to="/pti/list">PTI transaction</DropdownItem>
                                        {/*<DropdownItem tag={Link} className="text-dark" to="/dashboard/rpti">Reefer PTI</DropdownItem>*/}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to={'/shift'}>Shift Location</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to={"/Control"}>Control</NavLink>
                                </NavItem>
                                {/*<NavItem>*/}
                                {/*    <NavLink tag={Link} className="text-dark" to={'/RoutingQuery'}>Eq query</NavLink>*/}
                                {/*</NavItem>*/}
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to={'/EquipmentQuery'}>Equipment query</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to={'/lift'}>Lift</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to={'/Monitoring'}>Monitoring</NavLink>
                                </NavItem>
                                <LoginMenu>
                                </LoginMenu>
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
